import { BoldLabelText } from '@/components/BoldLabelText/BoldLabelText';
import { DescriptionCol, DescriptionRow } from '@/components/Description';
import {
  TransactionItemDrawerMode,
  TransactionItemDrawerModeEnum,
  TransactionItemFormType,
} from '@/features/transaction_items/List/type';
import { useTranslation } from '@/i18n';
import {
  Caption,
  FormCheckbox,
  Label,
} from '@moneyforward/ap-frontend-components';
import { FC, memo } from 'react';
import { UseFormReturn } from 'react-hook-form';

export type Props = {
  method: UseFormReturn<TransactionItemFormType>;
  mode: TransactionItemDrawerMode;
};

export const VisibilityCheckbox: FC<Props> = memo(({ method, mode }) => {
  const { t } = useTranslation();
  const { control, getValues } = method;

  return (
    <DescriptionRow>
      <DescriptionCol
        label={
          <Label testId='visibility'>
            <BoldLabelText>
              {t('transaction_items.table.is_visible')}
            </BoldLabelText>
          </Label>
        }
        labelWidth='176px'
      />
      <DescriptionCol
        value={
          <>
            {mode === TransactionItemDrawerModeEnum.DETAIL ? (
              <div data-testid='visibility-detail'>
                {getValues('is_visible')
                  ? t('transaction_items.table.visible')
                  : t('transaction_items.table.invisible')}
              </div>
            ) : (
              <div>
                <FormCheckbox<TransactionItemFormType>
                  name='is_visible'
                  control={control}
                  inputId='is_visible'
                  testId='visibility'
                  label={t('transaction_items.table.visible')}
                />
                <Caption type='helper'>
                  {t('transaction_items.visibility.caption')}
                </Caption>
              </div>
            )}
          </>
        }
      />
    </DescriptionRow>
  );
});
VisibilityCheckbox.displayName = 'VisibilityCheckbox';
